import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteMiniSiteCategoryMutation} from 'api';
import {useSnackbar} from 'notistack';

function MiniSiteCategoryDeleteIconButton({MiniSiteCategoryId}) {
  const [deleteMiniSiteCategory, deleteMiniSiteCategoryResult] =
    useDeleteMiniSiteCategoryMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteMiniSiteCategory(MiniSiteCategoryId).unwrap();
      enqueueSnackbar('MiniSiteCategory deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting MiniSiteCategory`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Category</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Category?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteMiniSiteCategoryResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteMiniSiteCategoryResult.isLoading}
            color="error"
            endIcon={deleteMiniSiteCategoryResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteMiniSiteCategoryResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default MiniSiteCategoryDeleteIconButton;
